const peerConfig = {

    peerURL: "webrtc.git.page",
    host: "/myapp"
}


module.exports = {
    peerConfig
}

